import React, { Component } from 'react'
import { AssignmentItemView } from '../../components'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import * as assignmentsItemViewActionCreators from '../../redux/modules/assignmentsItemView'
import { db } from '../../config/firebaseconfig'
import arrayifyWithKey from '../../helpers/arrayifyWithKey'
import queryString from 'query-string'
import timestamper from '../../helpers/timestamper'
import getNextItemLink from '../../helpers/getNextItemLink'
import findOneMostRecentActivity from '../../helpers/findOneMostRecentActivity'
const uuid = require('uuid/v1')
const has = require('mout/object/has')


// Add logic for detecting if an item is doable or viewable
// Add logic for processing when a student marks an answer
// Will eventually need test security so not server side or at least hidden

class AssignmentItemViewContainer extends Component {
  constructor(props) {
    super(props)

    this.createActivity = this.createActivity.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
  }

  componentDidMount() {
    const assignmentId = this.props.match.params.assignmentId
    const itemId = this.props.match.params.itemId

  // *** uncomment once dev is done 

  // const activeUser = this.props.user

  // ************************************

  // hardwire activeUser for dev purposes *************************
  
    const activeUser = {
      assignments: {
      '5eaaa260-c586-11e7-aaa4-5f88b808e68f': true,
      'dccfa070-c192-11e7-aa36-59c9a4365ff4': false

      },
      createdDate: 1509984211451,
      displayName: 'Student One',
      email: 'pesbatonrouge@gmail.com',
      groups: {
        '1007ae80-c40c-11e7-bcdf-779e5c4415b2': true,
        '3f3521e0-b54f-11e7-9d11-4fd67c837d82': false,
      },
      lastModifiedDate: 1509984211451,
      managesGroups: {
        '1007ae80-c40c-11e7-bcdf-779e5c4415b2': false,
      },
      role: 'Student',
      uid: 'ykpgIBcodOZMfPlYudsEc4rKtXG2'
    }
  
  // Comment out above hardwire once testing is done ***********************

  // Refactor below to helper function that is shared with AssignmentViewContainer

    let assignmentViewing = {}
  
    const getUserAssignment = (
      db.collection('userAssignments').doc(activeUser.uid).get()
        .then( (doc) => {
          assignmentViewing.userAssignment = doc.data()[assignmentId]
        })
    )

    const getAssignment = (
      db.collection('assignments').doc(assignmentId).get()
        .then( (doc) => {
          assignmentViewing.assignment = doc.data()
          const units = arrayifyWithKey(assignmentViewing.assignment.units)
          units.forEach((unit) => {
            if (unit.itemId === itemId) {
              assignmentViewing.activeItem = unit
            } 
          })
        })
    )

    this.props.fetchingData()
    Promise.all([getUserAssignment, getAssignment])
      .then( (values) => {
        this.props.fetchingDataSuccess(assignmentViewing)

        let mostRecentActivity = null
        if (has(this.props, 'userAssignment.activity') && has(this.props, 'activeItem.itemId')) {
          if (this.props.userAssignment.activity && this.props.activeItem.itemId) {
            mostRecentActivity = findOneMostRecentActivity(this.props.userAssignment.activity, this.props.activeItem.itemId)
            if (mostRecentActivity) {
              this.props.setMostRecentActivity(mostRecentActivity)
            }
          } 
        }
        
      })
      .catch( (err) => {
        console.log(err)
        this.props.fetchingDataError(err)
      })



  }

// *** Refactor so not repeating self in componentDidMount *** //

  componentWillReceiveProps(nextProps) {
  // change state if navigate to different item page
    if (nextProps.location.pathname !== this.props.location.pathname) {
      this.props.clearMostRecentActivity()
      const itemId = nextProps.match.params.itemId
      let newActiveItem
      const unitsArray = arrayifyWithKey(this.props.assignment.units)
      unitsArray.forEach( (unit) => {
        if (unit.itemId === itemId) {
          newActiveItem = unit
        }
      })
      this.props.setActiveItem(newActiveItem, false)
      let mostRecentActivity = null
      if (has(this.props, 'userAssignment.activity') && itemId) {
        if (this.props.userAssignment.activity && itemId) {
          mostRecentActivity = findOneMostRecentActivity(this.props.userAssignment.activity, itemId)
          if (mostRecentActivity) {
            this.props.setMostRecentActivity(mostRecentActivity)
          }

        } 
      }

    }
  }

  createActivity() {
    const activityId = uuid()
    return {
        userId: this.props.userAssignment.userId,
        verb: 'answered',
        activityId,
        assignmentId: this.props.assignment.assignmentId,
        userAssignmentId: this.props.userAssignment.userAssignmentId,
        itemId: this.props.activeItem.itemId,
        response: this.props.selectedAnswer,
        timestamp: timestamper(),
        correct: this.props.activeItem.answers[this.props.selectedAnswer].correct,
        grade: this.props.activeItem.answers[this.props.selectedAnswer].correct ? 1 : 0,
    }
  }

  handleSubmit() {
    this.props.submittingAnswer()
    const newActivity = this.createActivity()
    const userId = this.props.userAssignment.userId
    const assignmentId = this.props.assignment.assignmentId
    let submission
    if (this.props.userAssignment.activity) {
      submission = {
        [assignmentId]: {
          ...this.props.userAssignment,
          activity: {
            ...this.props.userAssignment.activity,
            [newActivity.activityId]: newActivity
          }
        }
      }
    } else {
      submission = {
        [assignmentId]: {
          ...this.props.userAssignment,
          activity: {
            [newActivity.activityId]: newActivity
          }
        }
      }
    }
    db.collection('userAssignments').doc(userId).set(submission, {merge: true})
      .then( () => this.props.submittingAnswerSuccess(newActivity))
      .catch( (err) => {
        console.log(err)
        this.props.submittingAnswerError(err)
      })
  }

  render() {

    let itemNumber = queryString.parse(this.props.location.search).item

    let nextItemLinkTo
    if (this.props.activeItem && this.props.assignment) {
      nextItemLinkTo = getNextItemLink(this.props.activeItem, this.props.assignment, itemNumber)
    }

    return (
      <AssignmentItemView
        isFetching={this.props.isFetching}
        assignment={this.props.assignment}
        userAssignment={this.props.userAssignment}
        error={this.props.error}
        user={this.props.user}
        activeItem={this.props.activeItem}
        itemNumber={itemNumber}
        selectedAnswer={this.props.selectedAnswer}
        selectAnswer={this.props.selectAnswer}
        handleSubmit={this.handleSubmit}
        completed={this.props.completed}
        nextItemLinkTo={nextItemLinkTo}
        mostRecentActivity={this.props.mostRecentActivity}
      />
     )
  }
}

export default connect(
  (state) => ({
    isFetching: state.assignmentsItemView.isFetching,
    assignment: state.assignmentsItemView.assignment,
    userAssignment: state.assignmentsItemView.userAssignment,
    error: state.assignmentsItemView.error,
    user: state.users.activeUser,
    activeItem: state.assignmentsItemView.activeItem,
    selectedAnswer: state.assignmentsItemView.selectedAnswer,
    completed: state.assignmentsItemView.completed,
    mostRecentActivity: state.assignmentsItemView.mostRecentActivity,
  }),
  (dispatch) => bindActionCreators(assignmentsItemViewActionCreators, dispatch)
)(AssignmentItemViewContainer)



// WEBPACK FOOTER //
// ./src/containers/Assignments/AssignmentItemViewContainer.js